import React from 'react';
import '../style/Lobby.css';

function Chat({ messages, input, setInput, sendMessage }) {
    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && input.trim()) {
            sendMessage();
        }
    };

    return (
        <div className="chat-container">
            <div className="chat-input-area">
                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Nachricht eingeben..."
                    className="chat-input"
                />
                <button onClick={sendMessage} className="button button-secondary">
                    <i className="fas fa-paper-plane"></i>
                </button>
            </div>

            <div className="messages" id="chat-messages">
                {[...messages].reverse().map((msg, index) => (
                    <div key={index} className="message-bubble">
                        <strong>{msg.userName}:</strong> {msg.message}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default React.memo(Chat);
